import { Row } from "@tanstack/react-table";
import { Eye, MoreHorizontal } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { TermRequest } from "../data/types";
import { useNavigate } from "react-router-dom";

interface DataTableRowActionsProps {
  row: Row<TermRequest>;
}

export function DataTableRowActions({ row }: DataTableRowActionsProps) {
  const navigate = useNavigate();

  const handleViewTerm = () => {
    navigate(
      `/retaguarda-de-loja/termo-de-tesouraria/visualizar/${row.original.id}`
    );
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          className="flex h-8 w-8 p-0 data-[state=open]:bg-muted bg-transparent border-none"
        >
          <MoreHorizontal className="h-4 w-4" />
          <span className="sr-only">Abrir menu</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[160px]">
        <DropdownMenuItem onClick={handleViewTerm}>
          <Eye className="mr-2 h-4 w-4" />
          Visualizar Solicitação
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
